module.exports = __webpack_public_path__ + "img/l.2393a098.jpg";